import { BackIcon } from "../../assets/icons";
import { IconAnimation } from "../../components/animation";
import { usePopupStore, useThemeStore } from "../../stores";
import { PopupBackProps } from "./types";

const PopupBack = <T extends {}>({ props, Component }: PopupBackProps<T>) => {
  const theme = useThemeStore((state) => state.theme);
  const setPopupBody = usePopupStore((state) => state.setPopupBody);

  const onClick = (): void => {
    setPopupBody(<Component {...props} />);
  };

  return (
    <IconAnimation
      Icon={BackIcon}
      onHoverColor={theme.secondary}
      width={24}
      height={24}
      style={{ cursor: "pointer", position: "absolute", top: 5, left: 10 }}
      onClick={onClick}
    />
  );
};

export default PopupBack;
